import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, CircularProgress } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useSnackbar } from 'notistack';
import M from 'messages';
import { getMessage } from 'helpers/helper';
import classes from '../styles';

function ResponseModal({ open, onClose, tasteimonial, onSave }) {
  const { enqueueSnackbar } = useSnackbar();
  const [response, setResponse] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && tasteimonial) {
      setResponse(tasteimonial.noteResponse || '');
    }
  }, [open, tasteimonial]);

  const handleSave = async () => {
    try {
      setLoading(true);
      await onSave(tasteimonial.id, response);
      enqueueSnackbar('Response saved successfully', { variant: 'success' });
      onClose();
    } catch (error) {
      enqueueSnackbar(getMessage(error?.response?.data, 'error'), { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setResponse('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle>{M.get('tasteimonials.responseModal.title')}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <span style={classes.tasteimonialLabel}>{M.get('tasteimonials.responseModal.tasteimonial')}:</span>{' '}
            {tasteimonial?.note}
          </Grid>
          <Grid size={{ xs: 12 }}>
            <TextField
              label={M.get('tasteimonials.responseModal.response')}
              value={response}
              onChange={e => setResponse(e.target.value)}
              multiline
              rows={3}
              fullWidth
              variant="outlined"
              placeholder={M.get('tasteimonials.responseModal.responsePlaceholder')}
              slotProps={{ htmlInput: { maxLength: 240 } }}
              sx={{ mt: 2 }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={classes.actionButtons}>
        <Button onClick={handleClose} color="primary" sx={classes.actionButton} disabled={loading}>
          {M.get('actions.discard')}
        </Button>
        <Button onClick={handleSave} color="primary" sx={classes.actionButton} variant="contained" disabled={loading}>
          {loading ? <CircularProgress size={16} /> : M.get('actions.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ResponseModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  tasteimonial: PropTypes.object,
  onSave: PropTypes.func.isRequired,
};

export default ResponseModal;
